import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import logo from "../assets/logo.png";
import useConfiguration from "../hooks/useConfiguration";
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import { configDataConstants, tableInfoConstants, } from "../store/actions/types";
import useUserConfiguration from "../utils/updateUserConfiguration";
import { tableTypeConstants } from "../store/actions/types";
import { ConfData3 as workStation } from "../const/const";
import { ConfData3 as heightAdjustableTable } from "../const/heightAdjustableTables";
import { ConfData3 as meetingTables } from "../const/meetingTables";
import { ConfData3 as discussionTables } from "../const/discussionTables";
import { ConfData3 as cabinTables } from "../const/cabinTablesNew";
import { ConfData3 as pedestals } from "../const/pedestals";
import { ConfData3 as _120Degree } from "../const/120Degree";
import { ConfData3 as planSystemLinear } from "../const/planSystemLinear";
import { ConfData3 as ccluster } from "../const/cCluster";
import { ConfData3 as chairs } from "../const/chairs";
import { makeSessionRequest } from "../utils/makeSessionRequest";
import { useHistory } from "react-router-dom";
export default function CategorySelector({ setShowCategorySelector, setIsStartingFromScratch, isStartingFromScratch, }) {
    const { updateConfiguration } = useConfiguration();
    const { updateUserConfiguration } = useUserConfiguration();
    const configData = useAppSelector((state) => state.configData.original);
    const [tableType, setTableType] = useState("Linear Workstation");
    const System = configData[0];
    const dispatch = useAppDispatch();
    const handleOptionSelection = (obj) => {
        updateConfiguration(System.name, [Object.assign({}, obj)]);
        updateUserConfiguration(System.name, obj);
        setShowCategorySelector(false);
    };
    const Card = ({ name, thumbnail }) => (_jsxs("div", Object.assign({ className: "bg-white filter hover:drop-shadow-c1 mr-4 mb-4 w-30  p-2 rounded-md flex flex-col items-center cursor-pointer", onClick: () => {
            dispatch({ type: tableInfoConstants.SET_TABLE_INFO, payload: name });
        } }, { children: [_jsx("img", { src: thumbnail, alt: "", className: "h-28 w-28 xl:w-36 xl:h-36 2xl:h-36 2xl:w-48 object-cover rounded-md mb-3" }), _jsx("h5", Object.assign({ className: "text-base xl:text-lg mb-2" }, { children: name }))] })));
    function toTitleCase(str) {
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }
    const allTables = [
        {
            name: "Linear Workstation",
            onclick: () => {
                setTableType("Linear Workstation");
                dispatch({
                    type: configDataConstants.SET_CONFIG_DATA,
                    payload: workStation,
                });
                // dispatch({
                //   type: configDataConstants.RESET_CURENT_CONFIG_DATA,
                // });
            },
        },
        {
            name: "Cabin Table",
            onclick: () => {
                setTableType("Cabin Table");
                dispatch({
                    type: configDataConstants.SET_CONFIG_DATA,
                    payload: cabinTables,
                });
            },
        },
        {
            name: "Pedestals",
            onclick: () => {
                setTableType("Pedestals");
                dispatch({
                    type: configDataConstants.SET_CONFIG_DATA,
                    payload: pedestals,
                });
            },
        },
        {
            name: "Meeting Table",
            onclick: () => {
                setTableType("Meeting Table");
                dispatch({
                    type: configDataConstants.SET_CONFIG_DATA,
                    payload: meetingTables,
                });
            },
        },
        {
            name: "C_Cluster",
            onclick: () => {
                setTableType("C_Cluster");
                dispatch({
                    type: configDataConstants.SET_CONFIG_DATA,
                    payload: ccluster,
                });
            },
        },
        // {
        //   name: "Conference Table",
        //   onclick: () => {
        //     setTableType("Conference Table");
        //     dispatch({
        //       type: configDataConstants.SET_CONFIG_DATA,
        //       payload: confTables,
        //     });
        //   },
        // },
        {
            name: "Discussion Table",
            onclick: () => {
                setTableType("Discussion Table");
                dispatch({
                    type: configDataConstants.SET_CONFIG_DATA,
                    payload: discussionTables,
                });
            },
        },
        {
            name: "Chairs",
            onclick: () => {
                setTableType("Chairs");
                dispatch({
                    type: configDataConstants.SET_CONFIG_DATA,
                    payload: chairs,
                });
            },
        },
        {
            name: "Height Adjustable Table",
            onclick: () => {
                setTableType("Height Adjustable Table");
                dispatch({
                    type: configDataConstants.SET_CONFIG_DATA,
                    payload: heightAdjustableTable,
                });
            },
        },
        {
            name: "120° Workstation",
            onclick: () => {
                setTableType("120° Workstation");
                dispatch({
                    type: configDataConstants.SET_CONFIG_DATA,
                    payload: _120Degree,
                });
            },
        },
        {
            name: "Plan System Linear",
            onclick: () => {
                setTableType("Plan System Linear");
                dispatch({
                    type: configDataConstants.SET_CONFIG_DATA,
                    payload: planSystemLinear,
                });
            },
        },
    ];
    const history = useHistory();
    const currentOrder = useAppSelector((state) => state.orders.currentOrder);
    if (currentOrder === null) {
        history.push("/dashboard");
    }
    return (_jsxs("div", Object.assign({ className: "flex flex-col items-center p-4" }, { children: [_jsx("img", { src: logo, alt: "", className: " w-62 h-auto object-contain mb-6" }), _jsxs("div", Object.assign({ className: "w-10/12" }, { children: [_jsx("div", Object.assign({ className: "flex flex-row overflow-hidden   items-center justify-center flex-wrap" }, { children: allTables.map((table, index) => {
                            return (_jsx("h6", Object.assign({ className: `text-center flex self-center  items-center text-sm p-4 h-24 w-56 lg:text-lg xl:text-xl font-bold mb-4 mx-3 rounded-lg cursor-pointer ${tableType === table.name
                                    ? "bg-white shadow-lg border-2 border-gray-100"
                                    : "border-2 border-gray-100"}`, onClick: () => {
                                    table.onclick();
                                    makeSessionRequest(`selected_table_type`, {
                                        table: table.name,
                                    });
                                }, style: { justifyContent: "center" } }, { children: table.name }), index));
                        }) })), _jsxs("div", Object.assign({ className: "flex flex-col items-center p-4" }, { children: [_jsxs("h6", Object.assign({ className: "text-xl lg:text-2xl xl:text-3xl font-bold mb-14" }, { children: ["CREATE YOUR ", tableType === null || tableType === void 0 ? void 0 : tableType.toUpperCase()] })), _jsx("div", Object.assign({ className: "flex justify-center items-center w-full" }, { children: _jsx("div", Object.assign({ className: `grid gap-10 justify-center px-24 xl:px-12 ${System.options.length > 1 ? "grid-cols-2" : "grid-cols-1"}` }, { children: System.options.map((option) => (_jsxs("div", Object.assign({ style: { minWidth: "27rem" }, className: "ml-8 shadow-lg rounded-lg pl-5" }, { children: [_jsx("h3", Object.assign({ className: "font-bold mb-4 text-sm xl:text-xl pl-5" }, { children: toTitleCase(option.name) })), _jsx("div", Object.assign({ className: `grid ${option.options.length >= 8 || option.options.length === 4
                                                    ? "grid-cols-4"
                                                    : "grid-cols-3"}` }, { children: option.options.map((option2) => (_jsx("div", Object.assign({ onClick: () => {
                                                        makeSessionRequest("selected_system", {
                                                            systemType: option.name,
                                                            system: option2.name,
                                                        });
                                                        handleOptionSelection({
                                                            name: option.name,
                                                            option: option2,
                                                        });
                                                        dispatch({
                                                            type: tableTypeConstants.SET_TABLE_TYPE,
                                                            payload: tableType,
                                                        });
                                                    } }, { children: _jsx(Card, { name: option2.name, thumbnail: option2.thumbnail }, option2.name) }), option2.name))) }))] }), option.name))) })) }))] }))] }))] })));
}
